import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import TitleMC from '../../../../components/TitleMC';
import InputMC from '../../../../components/InputMC';
import DropdownMC from '../../../../components/DropdownMC';
import IconMC from '../../../../components/IconMC';

import { useDocumentTypes } from '../../../../../hooks/useDocumentTypes';
import { useCountryOptions } from '../../../../../hooks/useCountryOptions';

const CustomerInfo = ({ customer }) => {
  const { t: tCommon } = useTranslation('Common');
  const { t } = useTranslation('Orders');

  const { getValues } = useFormContext();
  const { countryOptions, filterCountryOption } = useCountryOptions();
  const { documentTypeOptions } = useDocumentTypes();

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <TitleMC
        text={t('modal.basicInfo')}
        variant="H6"
        textClassName="!tw-font-semibold"
      />
      <div className="tw-flex tw-gap-2">
        <div className="tw-w-full">
          <InputMC
            id="first_name"
            name="customer.first_name"
            label={tCommon('form.first_name')}
            className="tw-resize-none tw-w-full"
            useFloatingLabel
          />
        </div>
        <div className="tw-w-full">
          <InputMC
            id="last_name"
            name="customer.last_name"
            label={tCommon('form.last_name')}
            className="tw-resize-none tw-w-full"
            useFloatingLabel
          />
        </div>
      </div>

      <div className="tw-flex tw-gap-2">
        <div className="tw-w-full">
          <InputMC
            id="email"
            name="customer.email"
            label={tCommon('form.email')}
            className="tw-resize-none tw-w-full"
            useFloatingLabel
          />
        </div>
        <div className="tw-flex tw-w-full tw-gap-2">
          <DropdownMC
            search
            useFloatingLabel
            id="country_id"
            name="customer.country_id"
            label={tCommon('form.country')}
            options={countryOptions}
            defaultValue={getValues('customer.country_id')}
            filterOption={filterCountryOption}
            className="!tw-w-[55%]"
            disabled={customer?.ws_active}
          />
          <div className="tw-w-full">
            <InputMC
              id="phone"
              name="customer.phone"
              label={tCommon('form.phone_number')}
              className="tw-resize-none !tw-w-full"
              useFloatingLabel
              placeholder="999999999"
              disabled={customer?.ws_active}
            />
          </div>
        </div>
      </div>

      <div className="tw-flex tw-gap-2">
        <div className="tw-flex tw-w-full tw-gap-2">
          <DropdownMC
            id="id_type"
            name="customer.id_type"
            label={tCommon('form.document_type')}
            className="!tw-w-[55%]"
            options={documentTypeOptions}
            defaultValue={getValues('customer.id_type')}
            useFloatingLabel
            placeholder={tCommon('form.placeholders.select')}
          />
          <div className="tw-w-full">
            <InputMC
              id="id_number"
              name="customer.id_number"
              label={tCommon('form.identification')}
              className="tw-resize-none"
              useFloatingLabel
            />
          </div>
        </div>
        <div className="tw-flex tw-w-full tw-gap-2">
          {customer?.ws_active && (
            <div className="tw-flex tw-items-center tw-rounded-full tw-bg-yellow-50 tw-border tw-border-yellow-100 tw-px-2 tw-py-1 tw-gap-1">
              <div className="tw-w-p-[1.33px]">
                <IconMC name="info-outline" className="tw-text-yellow-600" size="base" />
              </div>
              <span className="tw-text-yellow-600 tw-text-xs">{t('editPhoneNote')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(CustomerInfo);
